<script>
  import {onMount} from 'svelte'
  import { currentUser, userInfo } from "./store";
  import firebase from "firebase/app";
  import "firebase/firestore";

  let db = firebase.firestore();
  let promise;

  // Run a function that checks if the user exists
  // And create a user if they don't
  async function checkUser(user) {
    const query = await db.collection("users").where("id", "==", user.uid).get();

    if (!query.empty) {
      const snapshot = query.docs[0];
      const docid = snapshot.id
      const data = snapshot.data();
      data.docid = docid // We use this to reference the user object in firebase
      return data
    } else {
      db.collection("users").add({
        name: user.displayName,
        email: user.email,
        id: user.uid,
        image: user.photoURL,
        submissions: []
      }).then((docRef) => {
        
      }).catch((error) => {
        console.error('fuck', error)
      })
    }
  }

  onMount(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User

        currentUser.set(user)
        promise = checkUser(user).then((value)=> {
          // Set current userInfo
          userInfo.set(value)
        })
      } else {
        // User is signed out
        currentUser.set(null)
        userInfo.set(null)
      }
    });
  });
</script>